module.exports = __webpack_public_path__ + "static/media/Item_Head_F_00_Lv2_C.644debb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Equipment/Headgear/Item_Head_F_00_Lv2_C.png
// module id = ./src/assets/item/Equipment/Headgear/Item_Head_F_00_Lv2_C.png
// module chunks = 0